import { useDispatch } from 'react-redux';
import { useState, useCallback } from 'react';
import axiosInstance from './axiosInstance';
import { fetchUserAttributes ,fetchAuthSession,signOut, signInWithRedirect } from '@aws-amplify/auth';
import store from '../store/Store';


function useApi() {
    let token = store.getState().userContext.user.token;
    const dispatch = useDispatch();
    const [responses, setResponses] = useState({});
    const [loading, setLoading] = useState({});
    const [errors, setErrors] = useState({});

    const fetchData = useCallback(async (key, endpoint, method = 'GET', body = null) => {
        
        setLoading(prev => ({ ...prev, [key]: true }));
        try {
            const response = await axiosInstance({
                url: endpoint,
                method,
                data: body
            });
            setResponses(prev => ({ ...prev, [key]: response.data }));
        } catch (err) {
            setErrors(prev => ({ ...prev, [key]: err.response?.data?.message || 'Error fetching data' }));
        } finally {
            setLoading(prev => ({ ...prev, [key]: false }));
        }
    }, [token]);

    return { responses, loading, errors, fetchData };
}

export default useApi;
